export default __webpack_public_path__ + "static/media/Search.ffe29842.svg";